// export const REACT_APP_CLIENT_ID="995b209d3c304fafbdf12221b6bf0857";
export const REACT_APP_CLIENT_ID="89e0a607e2ad4c1d9d4e7ce01477d4ba";
export const REACT_APP_AUTHORIZE_URL="https://accounts.spotify.com/authorize";

/**
 * LOCAL Redirect URL
 */
// export const REACT_APP_REDIRECT_URL="http://localhost:3000";
/**
 * PROD Redirect URL
 */
export const REACT_APP_REDIRECT_URL="https://mini-spotify-clone.netlify.app/";